/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/isInteropObservable */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/util/isInteropObservable.mjs";
